import { Route, Routes } from 'react-router-dom';
import { JoinChannelTaskPage } from './Tasks/JoinChannelTask/JoinChannelTaskPage';
import { TaskContext, TasksTypes } from './TasksTypes';
import { VkShareTaskPage } from './Tasks/VkShareTask/VkShareTask';
import { InviteTaskPage } from './Tasks/InviteTask/InviteTaskPage';
import { AddToHomeScreenPage } from './Tasks/AddToHomeScreenTask/AddToHomeScreenPage';

export const TasksRoutes = () => {
    return (
        <Routes>
            <Route path='/' element={<TasksTypes />} />

            <Route path={ `/${TaskContext.JoinChannel}` } element={ <JoinChannelTaskPage /> } />
            <Route path={ `/${TaskContext.VkShare}` } element={ <VkShareTaskPage /> } />
            <Route path={ `/${TaskContext.Invite}` } element={ <InviteTaskPage /> } />
            <Route path={ `/${TaskContext.HomeScreenShortcur}` } element={ <AddToHomeScreenPage /> } />
        </Routes>
    );
};